// Printed receipt numbers: <prefix>/<booking code>-<n>. Customer and GST receipts each count on their own, oldest first.
import { buildBookingShortRefNo } from './documentRefs';

const millis = (v: any): number =>
  v?.toMillis ? v.toMillis() : v?.seconds ? v.seconds * 1000 : v ? Date.parse(String(v)) || 0 : 0;

const receiptCategory = (row: any) => String(row?.receiptCategory || '').toLowerCase();

/** Same order as the receipt PDF: cheque date, then transaction date, created, updated; undated last; id breaks ties. */
const receiptAt = (row: any) =>
  millis(row?.chqDate) || millis(row?.txnDate) || millis(row?.createdAt) || millis(row?.updatedAt) || Number.MAX_SAFE_INTEGER;

/** Receipt number of every customer and GST receipt in the list, by transaction id. */
export const receiptNumbers = (
  rows: any[],
  opts: { customerPrefix: string; shortBookingCode: string; bookingId: string }
): Map<string, string> => {
  const out = new Map<string, string>();
  if (!String(opts.shortBookingCode || '').trim()) return out;
  (['customer', 'gst'] as const).forEach((category) => {
    const ref = buildBookingShortRefNo(category === 'gst' ? 'GST' : opts.customerPrefix, opts.shortBookingCode, opts.bookingId);
    if (!ref) return;
    rows
      .filter((r) => String(r?.txnType || '').toLowerCase() === 'receipt' && receiptCategory(r) === category)
      .sort((a, b) => receiptAt(a) - receiptAt(b) || String(a?.id || '').localeCompare(String(b?.id || '')))
      .forEach((r, i) => out.set(String(r.id), `${ref}-${i + 1}`));
  });
  return out;
};

/** The receipt template's prefix for this project (assigned template first). */
export const receiptPrefixFor = (templates: Array<Record<string, any>>, projectId: string): string => {
  const list = templates.filter((t) => t?.templateId === 'payment_receipt_v1');
  const own = list.find((t) => {
    const ids = t?.assignedProjectIds || t?.projectIds || [];
    return Array.isArray(ids) && ids.includes(projectId);
  }) || list[0];
  return String(own?.visualModel?.refPrefix || '').trim();
};
